module.exports = __webpack_public_path__ + "img/img-3-4mobile.ce16ea1b.webp";